import React from 'react'
import { GatsbyImage, getImage, StaticImage } from 'gatsby-plugin-image'
import parser from 'html-react-parser'
import { Link } from 'gatsby'

export default function Content9({ data }) {
    const { content9ButtonText, content9LeftText, content9ButtonLink, content9Title, content9RightText, content9LeftImage, content9RightImage, content9ExternalButtonLink } = data;
    return (
        <div className='about-origins-wrap'>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-12 text-center'>
                        <figure className='abt-origins-icon'>
                            <StaticImage
                                src='../../../images/origins-icon.png'
                                alt='image'
                            />
                        </figure>
                        <h2 className='heading-level-2 blue-color'>{content9Title && parser(content9Title)}</h2>
                    </div>
                </div>
                <div className='row abt-origin-c-row'>
                    <div className='col-md-6 abt-orig-img-col'>
                        <figure>
                            <GatsbyImage
                                image={getImage(content9LeftImage?.localFile)}
                                alt='image'
                            />
                        </figure>
                    </div>
                    <div className='col-md-6 abt-orig-text-col'>
                        {content9RightText && parser(content9RightText)}
                    </div>
                </div>
                <div className='row abt-origin-c-row'>
                    <div className='col-md-6 abt-orig-img-col'>
                        <figure>
                            <GatsbyImage
                                image={getImage(content9RightImage?.localFile)}
                                alt='image'
                            />
                        </figure>
                    </div>
                    <div className='col-md-6 abt-orig-text-col'>
                        {content9LeftText && parser(content9LeftText)}
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-12 text-center abt-origins-btn-sec'>
                        {content9ExternalButtonLink ? (
                            <a href={content9ExternalButtonLink} className="btn blue-btn">
                                {content9ButtonText}
                            </a>
                        ) : content9ButtonLink ? (
                            <Link to={content9ButtonLink.uri} className='btn blue-btn'>
                                {content9ButtonText}
                            </Link>
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    )
}
